import React from 'react';

function Socials({
  SocialsContent,
  LanguageSelected,
  t,
  socialMediaIcons,divstyle
}) {
  return (
    <div>
      {SocialsContent && SocialsContent.length > 0 && (
        <div className={`pt-5 pb-5 pl-3 pr-3 ${divstyle} `}>
          <h1
            className={`${
              LanguageSelected == 'ar'
                ? 'title title--h1 first-title title__separate text-theme right-2'
                : 'title left-2 title--h1 first-title title__separate text-theme'
            }`}
          >
            {t("Réseaux sociaux")}
          </h1>
          <div className="flex items-center justify-center mt-3  ">
            <div className={`${LanguageSelected == 'ar' ? 'flex flex-wrap justify-center gap-1 w-full' : 'icon-containe'}`}>
              {SocialsContent.map((social, index) => (
                <a href={social.url} target='_blank' className='icon' key={index}>
                  {socialMediaIcons.map((icon) => {
                    if (social.nameSocial === icon.name) {
                      return (
                        <div className='image-container'>
                        <div class="white-fill"></div>
                        <img className='icon-social-media' src={icon.icon} alt={social.nameSocial} key={icon.name} />

                        </div>
                      );
                    }
                    return null;
                  })}
                </a>
              ))}
            </div>
          </div>
        </div>
       )}
    </div>
  );
}

export default Socials;
